import { map } from 'lodash';

export default {
    pickFields,
    filterFields,
    getInitialFilter,
    getMetadataColumns,
    withMetadataColumns
}

const generalFieldID = 'general';

function pickFields(fields) {
    let flatFields = [];
    for(let field of fields) {
        if(field.id==generalFieldID) {
            
            flatFields = flatFields.concat(field.columns);       
        }
        else {
            flatFields.push(field);
        }
    }
    return flatFields
    
}

function filterFields(columns, enabledColumns) {
    let enabledGroups = [];
    if(enabledColumns) {
        enabledGroups = enabledColumns.reduce((acc, val)=>{
            if(val.indexOf('.')!=-1) {
                const group = val.split('.')[0];
                if(!acc.includes(group))
                    acc.push(group);
            }
            return acc;
        }, enabledGroups)
        enabledColumns = enabledColumns.concat(enabledGroups);
    }
    columns = map(columns, (column)=>{
        if(enabledColumns !== undefined) {
            if(column.id==generalFieldID) {
                filterFields(column.columns, enabledColumns);
            }
            else {
                let show = enabledColumns.includes(column.id) ;
                if(column.columns!==undefined) {
                    column.columns.map(column=>column.show = (show && (column.expanded || column.accessor == 'total')));
                }
                if(column.hasOwnProperty('expanded'))
                    show = show && column.expanded;
                
                column.show = show;
            }
        }
        return column;
    });
    return columns;
}

function getInitialFilter(fields) {
    let filter = []; 
    fields = fields.filter(item=>(item.show===undefined || item.show===true));
    for(let field of fields) {
        if(field.id==generalFieldID) {
            filter = filter.concat(field.columns.map(field=>field.id));
        }
        else
            filter.push(field.id)
    }
    return filter;
}

function getMetadataColumns(fields) {
    if(!Array.isArray(fields))
        return [];
    return pickFields(fields)
        .filter(field=>field && field.metadata===true && field.id && field.id.indexOf('.')==-1)
        .map(field=>field.id);
}

function withMetadataColumns(queryColumns, fields) {
    const columns = Array.isArray(queryColumns) ? queryColumns.slice(0) : [];
    const metadataColumns = getMetadataColumns(fields).filter(id=>!columns.includes(id));
    return metadataColumns.concat(columns);
}